import React, { createContext, useContext, useEffect, useState } from 'react';
import { fetchSite, mergeSite, fallbackSite } from '../lib/cms';

const CmsContext = createContext(fallbackSite);

/**
 * Lädt die gepflegten Inhalte einmal beim Start. Bis die Antwort da ist -
 * und falls sie ausbleibt - werden die im Code hinterlegten Inhalte
 * angezeigt. Die Seite ist dadurch nie leer.
 */
export const CmsProvider = ({ children }) => {
  const [site, setSite] = useState(fallbackSite);

  useEffect(() => {
    let cancelled = false;

    fetchSite()
      .then((data) => {
        if (!cancelled) {
          setSite(mergeSite(data));
        }
      })
      .catch(() => {
        // Kein Grund, die Seite zu stören: die Standardinhalte stehen bereits.
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return <CmsContext.Provider value={site}>{children}</CmsContext.Provider>;
};

/** Alle Inhalte. */
export const useCms = () => useContext(CmsContext);

/** Ein Textabschnitt, z. B. useSection('about'). */
export const useSection = (name) => {
  const site = useCms();
  return site.content[name] || {};
};

/** Eine Bilderliste, z. B. useSlider('hero'). */
export const useSlider = (name) => {
  const site = useCms();
  return site.media[name] || [];
};

export default CmsContext;
